// extracted by mini-css-extract-plugin
export default {"container":"Activities_Edit_container__OnM-s","actions":"Activities_Edit_actions__i-+gQ"};